import type { ReactNode } from 'react';
import { Button } from '../atoms/Button.js';
import { Typography } from '../atoms/Typography.js';

interface EmptyStateProps {
  icon?: ReactNode;
  title: string;
  description?: string;
  actionLabel?: string;
  onAction?: () => void;
  className?: string;
}

export function EmptyState({
  icon,
  title,
  description,
  actionLabel,
  onAction,
  className = '',
}: EmptyStateProps) {
  return (
    <div className={`flex flex-col items-center justify-center py-12 text-center ${className}`}>
      {icon && <div className="mb-4 text-neutral-300">{icon}</div>}
      <Typography variant="h4" className="!text-neutral-600">
        {title}
      </Typography>
      {description && (
        <Typography variant="body-sm" className="mt-2 max-w-sm">
          {description}
        </Typography>
      )}
      {actionLabel && onAction && (
        <Button onClick={onAction} className="mt-4">
          {actionLabel}
        </Button>
      )}
    </div>
  );
}
